// extracted by mini-css-extract-plugin
export default {"chip":"ScoreTag-module__chip__2JFs2","label":"ScoreTag-module__label__BypS2","score":"ScoreTag-module__score__sdEQY"};